import Box from '@mui/material/Box';
import type { MetaFunction } from '@remix-run/node';
import { useRouteLoaderData } from '@remix-run/react';
import * as React from 'react';
import BulkSwag from '~/components/Home/BulkSwag';
import GetYourSwag from '~/components/Home/GetYourSwag';
import Intro from '~/components/Home/Intro';
import OurPromise from '~/components/Home/OurPromise';
import SwagForAll from '~/components/Home/SwagForAll';
import SwagPacks from '~/components/Home/SwagPacks';
import TechnologyFirstCompany from '~/components/Home/TechnologyFirstCompany';
import TrustPartners from '~/components/Home/TrustPartners';
import type { LoaderData as RootLoaderData } from '~/root';
import { getModifiedTime } from '~/utils/common.server';
import { useFlags } from '~/utils/contexts';
import type { SitemapHandle } from '~/utils/sitemap.server';

export const handle: SitemapHandle = {
  getSitemapEntries: () => {
    const path = require('path');
    const indexModTime = getModifiedTime(__filename);
    const homeDirModTime = getModifiedTime(path.resolve(__dirname, '..', 'app/components/Home'));
    const lastMod = indexModTime > homeDirModTime ? indexModTime : homeDirModTime;
    return {
      route: '',
      lastmod: lastMod.toISOString(),
      changefreq: 'daily',
      priority: 1,
    };
  },
};

export const meta: MetaFunction = () => ({
  title: 'SwagCharm | The true tech first Swag Company',
});

export default function HomePage() {
  const { ENV } = useRouteLoaderData('root') as RootLoaderData;
  const { test: testFlag } = useFlags();

  React.useEffect(() => {
    if (ENV.NODE_ENV === 'development') {
      // don't delete (example of how to use feature flags in components)
      console.log('testFlag:', testFlag);
    }
  }, [ENV.NODE_ENV, testFlag]);

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Intro />
      <TrustPartners />
      <SwagPacks />
      <BulkSwag />
      <TechnologyFirstCompany />
      <SwagForAll />
      <OurPromise />
      <GetYourSwag />
    </Box>
  );
}
